const urlPage = 'https://uniline.online';


export default urlPage